export async function handleOnInitiatePaymentQueryStarted(arg: any, { dispatch, queryFulfilled, getState }: any) {
  try {
    const { data } = await queryFulfilled
    const { url } = data
    if (!url) return
    window.location.href = url
  } catch (error) {
    console.error(`Error initiating payment. Error:`, error)
  }
}
